export default __webpack_public_path__ + "static/media/minBst.4fd466d5.jpg";